module.exports = __webpack_public_path__ + "img/madagascar.6ab4fb25.png";